import { createSlice } from '@reduxjs/toolkit';
import { getPartnerRelationshipManager } from '../../services/partners/relationshipManager';

// The relationship manager shown to the *current* partner's users (sidebar
// card). Keyed by partnerId so a manager loaded for one partner context is
// never shown after "Manage Account" switches to another.
const initialState = {
  partnerId: null,
  manager: null,
  isLoading: false,
  error: null,
};

const relationshipManagerSlice = createSlice({
  name: 'relationshipManager',
  initialState,
  reducers: {
    startLoading(state, action) {
      state.partnerId = action.payload;
      state.manager = null;
      state.error = null;
      state.isLoading = true;
    },
    fetchSuccess(state, action) {
      state.manager = action.payload;
      state.isLoading = false;
    },
    hasError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export default relationshipManagerSlice.reducer;

export const getRelationshipManagerState = (state) => state.relationshipManager;

export function fetchRelationshipManager(partnerId) {
  return async (dispatch) => {
    dispatch(relationshipManagerSlice.actions.startLoading(partnerId));
    try {
      const data = await getPartnerRelationshipManager(partnerId);
      dispatch(relationshipManagerSlice.actions.fetchSuccess(data?.relationship_manager || null));
    } catch (error) {
      dispatch(
        relationshipManagerSlice.actions.hasError(
          error?.response?.data?.message || error?.message || 'Failed to load relationship manager'
        )
      );
    }
  };
}
